<template>
    <div class="armenians-loader" role="status" :aria-label="ariaLabel || undefined">
        <div ref="animation" class="armenians-loader__animation"></div>
    </div>
</template>

<script>
import { mountArmeniansLoader, unmountArmeniansLoader } from '../core/armeniansLoader';

export default {
    name: 'ArmeniansLoader',

    props: {
        ariaLabel: {
            type: String,
            default: '',
        },
    },

    mounted() {
        mountArmeniansLoader(null, this.$refs.animation);
    },

    beforeDestroy() {
        unmountArmeniansLoader(this.$refs.animation);
    },
};
</script>
